module.exports = __webpack_public_path__ + "static/media/rocket-bg.d39a8de1.webp";